import React from 'react';
import { observer } from 'mobx-react';

import { routeNode } from 'core/routing';

import FilesPageRouter from 'apps/files/router';
import ProjectsPageRouter from 'apps/projects/router';
import { SettingsRouter } from 'apps/workspace/settings/router';
import RFQsPage from 'apps/rfq/rfqList/page';

import OrdersPage from 'apps/order/orderList/page';
import { MicroSite } from 'apps/microSite/index';
import { clientStore } from 'apps/client/app';

import { inWhitelabel } from 'core/whitelabel';
import { useNoAuthRedirect } from 'apps/hooks';

import { MainWrapper } from 'legacyComponents/styled/lib';
import { Tabs, Tab } from 'components';
import WorkspaceIndicator from 'apps/workspace/WorkspaceIndicator';

import { Cube, Folder, Factory, Buy, Quotes } from 'icons';

import { QuoteListPage } from '../shipmentQuote/QuoteListPage';

import { FourOhFour } from '../fourOhFour';

import Dashboard from './dashboard';

const viewsMap = {
  '': inWhitelabel() ? MicroSite : Dashboard,
  // dashboard: Dashboard,
  spaceFiles: FilesPageRouter,
  spaceProjects: ProjectsPageRouter,
  rfqs: RFQsPage,
  quotes: QuoteListPage,
  orders: OrdersPage,
  spaceSettings: SettingsRouter,
};

const WorkspaceRouter = observer(props => {
  useNoAuthRedirect();
  const { route, routerStore } = props;

  let segment;
  const isIntermediator = clientStore.currentPortal === 'INTERMEDIATOR';
  if (['INTERMEDIATOR', 'MANUFACTURER'].includes(clientStore.currentPortal)) {
    [, , segment] = route.name.split('.'); // workspace.intermediator.segment
  } else {
    [, segment] = route.name.split('.'); // workspace.segment
  }
  if (!segment) {
    // if not in whitelabel render the content of workspace.spaceFiles
    if (inWhitelabel()) segment = '';
    else segment = 'spaceFiles';
  }
  const View = viewsMap[segment] || FourOhFour;

  let shouldRenderTabs = true;
  if (route.name.startsWith('workspace.spaceSettings')) {
    shouldRenderTabs = false;
  }

  let tabs = null;
  if (route.name === props.routeNode || 2 > 1) {
    let rfqsTabValue = 'workspace.rfqs';
    let ordersTabValue = 'workspace.orders';
    let quotesTabValue = 'workspace.quotes';
    if (isIntermediator) {
      rfqsTabValue = 'workspace.intermediator.rfqs';
      ordersTabValue = 'workspace.intermediator.orders';
      quotesTabValue = 'workspace.intermediator.quotes';
    }
    let tabsValue = route.name;
    if (tabsValue === 'workspace') tabsValue = 'workspace.spaceFiles';
    tabs = (
      <Tabs
        value={tabsValue}
        onClick={(event, value) => {
          routerStore.router.navigate(value, {
            spacePath: route.params.spacePath,
          });
        }}
      >
        <Tab value='workspace.spaceFiles' icon={<Cube />}>
          Files
        </Tab>
        <Tab value='workspace.spaceProjects' icon={<Folder />}>
          Projects
        </Tab>
        <Tab value={rfqsTabValue} icon={<Factory />}>
          RFQs
        </Tab>
        <Tab value={quotesTabValue} icon={<Quotes />}>
          Quotes
        </Tab>
        <Tab value={ordersTabValue} icon={<Buy />}>
          Orders
        </Tab>
      </Tabs>
    );
  }

  return (
    <>
      <MainWrapper>
        <WorkspaceIndicator />
        {shouldRenderTabs && tabs}
      </MainWrapper>
      <View params={props.routerStore.params} />;
    </>
  );
});

export default routeNode('workspace', viewsMap, FourOhFour)(WorkspaceRouter);
